<template>
  <md-card id="report_toolbar">
    <div class="md-layout">
      <md-button
        class="md-primary md-sm download-button"
        v-for="button in buttons"
        :key="button.component"
        @click.prevent="$emit('showReport', button.component)"
      >
        {{ button.desc }}
      </md-button>
    </div>
  </md-card>
</template>
<script>
export default {
  name: "ReportToolbar",

  props: {
    buttons: Array
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
#report_toolbar {
  margin: 10px 0;

  .md-layout {
    padding: 10px;
    justify-content: flex-start;
  }

  .download-button {
    margin: 3px;
  }
}
</style>
